import { Store, toImmutable, Immutable } from 'nuclear-js'
import { User, StoreState } from '../types'

const storeName: string = 'user'

const getters = {
  user: [storeName, 'user'],
  uiState: [storeName, 'uiState']
}

const setters = {
  setUser: (state: StoreState, user: User): StoreState => {
    return state.set('user', Immutable.Map(user))
  },

  setUiState: (state: StoreState, data:{key: string, value: any}): StoreState => {
    return state.setIn(['uiState', data.key], data.value)
  },

  updateUser: (state: StoreState, updates: Object): StoreState => {
    return state.mergeIn(['user'], updates)
  }
}

const operations = {
  setUser: 'setUser',
  setUiState: 'setUiState',
  updateUser: 'updateUser'
}

const store = new Store({
  getInitialState() {
    return toImmutable({
      user: null,
      uiState: {
        customerNavExpiredExpanded: false,
        customerNavFilterString: '',
        expandedPostBoxId: ''
      }
    })
  },
  initialize() {
    const store: Store = this // for type checking
    store.on(operations.setUser, setters.setUser)
    store.on(operations.setUiState, setters.setUiState)
    store.on(operations.updateUser, setters.updateUser)
  }
})

export {
  store as userStore,
  operations as userOperations,
  getters as userGetters,
  setters as userSetters
}
